import { SEO_PAGES, SITE_ORIGIN } from "../constants/seo";
import { ROUTES } from "../constants/routes";

const PATH_TO_PAGE = Object.entries(SEO_PAGES).reduce((acc, [pageId, config]) => {
  if (config.path && pageId !== "productDetail") {
    acc[config.path] = pageId;
  }
  return acc;
}, {});

PATH_TO_PAGE[ROUTES.legacyHome] = "home";

export function resolveSeoPageId(pathname) {
  const normalized = pathname.replace(/\/+$/, "") || "/";

  if (
    normalized.startsWith(`${ROUTES.products}/`) &&
    normalized !== ROUTES.products
  ) {
    return "productDetail";
  }

  return PATH_TO_PAGE[normalized] || "home";
}

export function buildAbsoluteUrl(path) {
  const origin =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : SITE_ORIGIN;

  if (path.startsWith("http")) {
    return path;
  }

  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${origin}${normalizedPath}`;
}
